// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__a7Cvc","map":"styles_map__KBDcO"};